import { useState } from 'react'
import { ButtonCommon } from 'src/common'
import PopconfirmCommon from 'src/common/PopconfirmCommon/PopconfirmCommon'
import { useAppDispatch } from 'src/hooks'
import { onConfirmOrder } from 'src/redux/order/order.action'
import { ORDER_STATUS } from 'src/utils/constant'
import { showMessageError, showMessageSuccess } from 'src/utils/function.utils'
import { trackSubscriptionActivated } from 'src/utils/ga4.utils'

export const OrderAction = ({
	id,
	orderStatus,
	userID,
	subscriptionCode,
	method,
	transactionID,
}) => {
	const dispatch = useAppDispatch()

	const [visibleConfirmAcceptOrder, setVisibleConfirmAcceptOrder] = useState(
		false
	)
	const [confirmAcceptLoading, setConfirmAcceptLoading] = useState(false)

	const [visibleConfirmRejectOrder, setVisibleConfirmRejectOrder] = useState(
		false
	)
	const [confirmRejectLoading, setConfirmRejectLoading] = useState(false)

	// accept order
	const handleAcceptOrder = () => {
		setConfirmAcceptLoading(true)
		dispatch(
			onConfirmOrder(
				{ orderID: id, isSuccess: true },
				(isSuccess, rs) => {
					setConfirmAcceptLoading(false)
					if (isSuccess) {
						setVisibleConfirmAcceptOrder(false)
						showMessageSuccess('Update successfully!')
						const order = rs && typeof rs === 'object' ? rs : {}
						trackSubscriptionActivated({
							userID: order.userID || userID,
							orderID: order.id || id,
							subscriptionCode:
								order.subscriptionCode || subscriptionCode,
							method: order.method || method,
							transactionID:
								order.transactionID || transactionID,
						})
					} else {
						showMessageError(rs)
					}
				}
			)
		)
	}

	const closePopupConfirmAccept = () => {
		setVisibleConfirmAcceptOrder(false)
	}

	const openPopupConfirmAccept = () => {
		setVisibleConfirmAcceptOrder(true)
	}

	// reject order
	const handleRejectOrder = () => {
		setConfirmRejectLoading(true)
		dispatch(
			onConfirmOrder(
				{ orderID: id, isSuccess: false },
				(isSuccess, rs) => {
					setConfirmRejectLoading(false)
					if (isSuccess) {
						setVisibleConfirmRejectOrder(false)
						showMessageSuccess('Update successfully!')
					} else {
						showMessageError(rs)
					}
				}
			)
		)
	}

	const closePopupConfirmReject = () => {
		setVisibleConfirmRejectOrder(false)
	}

	const openPopupConfirmReject = () => {
		setVisibleConfirmRejectOrder(true)
	}

	return (
		<div>
			{orderStatus === ORDER_STATUS.PENDING && (
				<div className="u-row-center">
					<PopconfirmCommon
						visible={visibleConfirmRejectOrder}
						onConfirm={handleRejectOrder}
						title={
							<>
								Are you sure to confirm this order is{' '}
								<strong>failed</strong>?
							</>
						}
						placement="left"
						okButtonProps={{ loading: confirmRejectLoading }}
						onCancel={closePopupConfirmReject}
					>
						<ButtonCommon
							onClick={openPopupConfirmReject}
							ghost
							type="danger"
						>
							Reject
						</ButtonCommon>
					</PopconfirmCommon>

					<PopconfirmCommon
						visible={visibleConfirmAcceptOrder}
						onConfirm={handleAcceptOrder}
						title={
							<>
								Are you sure to confirm this order is{' '}
								<strong>successful</strong> and upgrade this
								user to <strong>Premium</strong>?
							</>
						}
						placement="left"
						okButtonProps={{ loading: confirmAcceptLoading }}
						onCancel={closePopupConfirmAccept}
					>
						<ButtonCommon
							onClick={openPopupConfirmAccept}
							type="primary"
						>
							Accept
						</ButtonCommon>
					</PopconfirmCommon>
				</div>
			)}
		</div>
	)
}
